<app-ticket-view *ngIf="!TicketsVieworEntry" [ViewInput]="isListorUpdateView"   [clientTab]="clientTab"
  (ViewOutput)="EmitChildComponent($event)"></app-ticket-view>

  <app-ticket-entry *ngIf="TicketsVieworEntry" [EntryInputProperty]="isListorUpdateView"   [clientTab]="clientTab"
  (EntryOutputTimesheet)="EmitChildComponent($event)"></app-ticket-entry>
